<script>
import ImageLoader from '../shared/ui/ImageLoader';
import RatioContainer from '@/launcher/components/shared/ui/RatioContainer';
import CallHelpBtnConnected from '../connected/ui/CallHelpBtnConnected';
import HelpRequestedNotification from '@/launcher/components/shared/notifications/HelpRequestedNotification';
import LoadingRing from '@/launcher/components/shared/LoadingRing';

export default {
  name: 'GameDetailsBox',
  props: {
    game: {
      required: true,
    },
    loading: {
      type: Boolean,
    },
    canStart: {
      type: Boolean,
      required: true,
    },
    hasCalledHelp: {
      type: Boolean,
      required: true,
    },
    waitingLaunch: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    RatioContainer,
    LoadingRing,
    CallHelpBtnConnected,
    HelpRequestedNotification,
    ImageLoader,
  },
};
</script>

<template lang="pug">
div.game-details-box.white.flex.flex-column
  .bg-black-overlay.pt4.relative.flex-auto.h0._collision
    div.loadingoverlay.absolute.absolute--fill.flex.justify-center.items-center.z-2.bg-darkest-black-overlay(v-if="waitingLaunch")
      loading-ring
    div.flex-auto.flex.flex-column.relative.h-100
      template(v-if="!loading")
        header.header.cf.ph4.flex.w-100
          div.pr2.flex-auto
            h3.cat.fw7.ttu.f6 {{ game.tags[0] && game.tags[0].text }}
            h3.title.fw7.f2.w-90.mv3.lh-title {{ game.title }}
            div.logos
              icon.difficultyicon.h1.mr3(:name="game.difficultyName")
              icon.singleplayericon.h1.mr3.fill-white(name="singleplayer", v-if="game.singleplayer")
              icon.multiplayericon.h1.mr3.fill-white(name="multiplayer", v-if="game.multiplayer", viewBox="0 0 15 11")
          div.w-30.shrink-0
            RatioContainer
              ImageLoader.coverimg.db.w-100.h-100.fit-cover(:src="game.imageUrl")
        scroll-element.flex-auto(:paddingTop="30")
          div
            p.desc.white.lh-copy.f6.ph4.mb2.fw4.overflow-hidden.flex-auto(v-html="game.description")
  div.nav.mt2.flex
    cta-style
      button.backbtn.flex-auto.w-50.pa3.f5.dib.mr2(@click="$emit('cancel', game)", type="button") {{ $t('Back') }}
    cta-style(v-if="canStart", accent)
      button.launchbtn.dib.flex-auto.w-50.pa3.f5(v-sound="'progress'", :disabled="loading || waitingLaunch", @click="$emit('launch', game.id)", type="button")
        icon.mr3.fill-inherit.w1.v-mid(name="play")
        span.dib.v-mid {{ $t('Start') }}
    CallHelpBtnConnected.helpbtn.dib.flex-auto.w-50(v-else)
      | {{$t('Call help to play')}}
  div.helprequested.left-50.translate-x--50.absolute
    HelpRequestedNotification.ph3(v-show="hasCalledHelp")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.game-details-box {
  & .helprequested {
    bottom: -4rem;
  }
  & >>> .-can-up {
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black 3rem
    ) !important;
  }
  & .imgwrapper {
    position: relative;
    &:before {
      display: block;
      content: "";
      width: 100%;
      /* 16:9 */
      padding-top: 56.25%;
    }
    > * {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
